<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ReleaseDocumentNumberApplication')"
    :width="$selectByLang('450px', '450px', '550px')"
    :close-on-click-modal="false"
  >
    <el-form ref="releaseForm" :model="releaseForm" :rules="rules" :label-width="$selectByLang('140px', '140px', '180px')" label-position="left" class="release-application-form">
      <el-form-item :label="$t('CargoMsg.Cargo_ReleaseNumberDocument')" prop="releaseType">
        <el-select v-model="releaseForm.releaseType" style="width: 100%">
          <el-option :label="$t('CargoMsg.Cargo_ReleaseNumber')" :value="0" />
          <el-option :label="$t('CargoMsg.Cargo_ReleaseDocument')" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_IsPaymentReceived')" prop="paymentReceived">
        <el-select v-model="releaseForm.paymentReceived" style="width: 100%">
          <el-option :label="$t('CargoMsg.Cargo_Yes')" :value="true" />
          <el-option :label="$t('CargoMsg.Cargo_No')" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_PaymentTime2')" prop="paymentTime">
        <el-date-picker
          v-model="releaseForm.paymentTime"
          type="date"
          style="width: 100%"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="type==='number'" :label="$t('CargoMsg.Cargo_ReleaseNumberQuantity')" prop="releaseQuantity">
        <el-input v-model="releaseForm.releaseQuantity" type="number" :min="1" />
      </el-form-item>
      <el-form-item v-if="type==='document'" :label="$t('CargoMsg.Cargo_BLNo')" prop="billNo">
        <el-input v-model="releaseForm.billNo" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_RelatedAttachments')" prop="attachments">
        <div class="upload-file-row">
          <template v-if="hasReleaseUploadedFile">
            <span class="upload-file-name">{{ getUploadedFileName() }}</span>
            <el-button class="upload-file-remove" type="text" icon="el-icon-close" @click="handleRemoveUpload" />
          </template>
          <el-button v-else size="small" type="primary" @click="cloudFile.visible = true">
            {{ $t('CargoMsg.Cargo_Upload') }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Application_Reason')" prop="applicationReason">
        <el-input v-model="releaseForm.applicationReason" type="textarea" :rows="4" />
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto; width: fit-content;">
      <el-button type="primary" no="submit" @click="handleSubmit">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      @uploadDone="uploadSuccess"
    />
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import DropUploader from '@/components/Cargo/Common/DropUploader.vue'
import { Project } from '@/class/model/pm/Project'
import { applyReleaseApplication } from '@/api/company'

export default {
  name: 'ReleaseApplicationDialog',
  components: { DropUploader, cargoCloudFileUpload, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    cmpIdx: { type: Number, default: 0 },
    type: { type: String, default: 'number' }
  },
  data() {
    const validateQuantityFile = (rule, value, callback) => {
      if (this.releaseForm.releaseType === 0 && (!value || value <= 0)) {
        callback(new Error(this.$t('CargoMsg.Cargo_PlsInput')))
      } else {
        callback()
      }
    }
    const validateHbl = (rule, value, callback) => {
      if (this.releaseForm.releaseType === 1 && !value) {
        callback(new Error(this.$t('CargoMsg.Cargo_PlsInput')))
      } else {
        callback()
      }
    }
    const validateFile = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelectFile')))
      } else {
        callback()
      }
    }
    return {
      innerVisible: false,
      rules: {
        releaseType: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        paymentReceived: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        paymentTime: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        releaseQuantity: [
          { required: true, validator: validateQuantityFile, trigger: 'blur' }
        ],
        billNo: [
          { required: true, validator: validateHbl, trigger: 'blur' }
        ],
        applicationReason: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        attachments: [
          { required: true, validator: validateFile, trigger: 'change' }
        ]
      },
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: 'allLob'
      },
      releaseForm: {
        cmpIdx: 0, // 合作伙伴ID
        releaseType: 0, // 放号/放单
        paymentReceived: false, // 是否收款 否 是
        paymentTime: null, // 收款时间
        releaseQuantity: 0, // 放号数量
        billNo: '', // 提单号
        fileList: [], // 附件列表
        attachments: '',
        applicationReason: '' // 申请原因
      }
    }
  },
  computed: {
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    hasReleaseUploadedFile() {
      return !!(this.releaseForm && Array.isArray(this.releaseForm.fileList) && this.releaseForm.fileList.length > 0)
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.initData()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    async initData() {
      // 重置所有表单字段
      this.releaseForm = {
        cmpIdx: 0,
        releaseType: this.type !== 'document' ? 0 : 1,
        paymentReceived: false,
        paymentTime: null,
        releaseQuantity: 0,
        billNo: '',
        fileList: [],
        attachments: '',
        applicationReason: ''
      }
      // 重置表单验证
      this.uploadedFiles = {
        creditSelfAssessment: [],
        customerProfile: [],
        customerCommission: []
      }
      this.companyUserPartner = {
        uuid: '',
        companyUsers: [],
        deletedCompanyUserKeys: []
      }
      this.$nextTick(() => {
        if (this.$refs.releaseForm) {
          this.$refs.releaseForm.clearValidate()
        }
      })
    },
    getUploadedFileName() {
      const files = (this.releaseForm && this.releaseForm.fileList) || []
      const names = files.map(f => f && f.fileName).filter(Boolean)
      if (names.length > 0) {
        return names.join(', ')
      }
      return this.$t('SeaExport.UploadedFile')
    },
    handleRemoveUpload() {
      this.releaseForm.fileList = []
      this.releaseForm.attachments = ''
    },
    async uploadSuccess(data) {
      try {
        const list = []
        const fileInfoList = []
        for (const item of data) {
          if (item.fileId) {
            list.push(item.fileId)
            fileInfoList.push({
              fileId: item.fileId,
              fileName: item.fileName || item.name || ''
            })
          }
        }
        this.releaseForm.attachments = list.join(',')
        this.releaseForm.fileList = list
        this.cloudFile.visible = false
      } catch (e) {
        console.log(e)
      }
    },
    // 提交表单
    async handleSubmit() {
      this.$refs.releaseForm.validate(async(valid) => {
        if (!valid) {
          return false
        }
        const loading = getLoading4Cxt(this)
        try {
          const res = await applyReleaseApplication(this.releaseForm)
          if (res.ok) {
            this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
            this.innerVisible = false
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_SubmitException'))
          }
        } finally {
          loading.close()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.release-application-form {
  ::v-deep .el-form-item {
    margin-bottom: 15px !important;
  }
}

::v-deep .el-form-item__label {
  font-weight: 500;
}

::v-deep .el-textarea {
  .el-textarea__inner {
    font-family: inherit;
  }
}

.upload-file-row {
  display: flex;
  align-items: center;
}

.upload-file-name {
  max-width: 560px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-remove {
  padding: 0 4px;
  margin-left: 6px;
  line-height: 1;
}
</style>
